module.exports = __webpack_public_path__ + "static/media/retrato_2.5bae4fe3.jpg";